export default {
  flashSalesBanner: {
    id: 'flash_sales_product_page_banner_flash_deal',
    defaultMessage: 'Flash Deal: Includes {discount} off at checkout',
  },
  sellerFlashSalesBanner: {
    id: 'flash_sales_product_page_banner_price_drop',
    defaultMessage: 'Price recently dropped {priceDrop}',
  },
} as const
